/**
 * Rewrite a survey URL to use the current app origin.
 * When testing locally (e.g. localhost:3000), API returns production URLs
 * (e.g. https://insights.welbee.co.uk/survey-view/...). This keeps the path
 * and query but uses window.location.origin so the survey opens in the same
 * app the user is in (local or production).
 * @param {string} apiUrl - Full URL returned by the API
 * @returns {string} URL with current origin, or apiUrl if invalid
 */
export function surveyUrlForCurrentOrigin(apiUrl) {
  if (!apiUrl || typeof apiUrl !== 'string') return apiUrl;
  try {
    const url = new URL(apiUrl);
    if (url.origin === window.location.origin) return apiUrl;
    return window.location.origin + url.pathname + url.search;
  } catch {
    return apiUrl;
  }
}
